module.exports = __webpack_public_path__ + "static/img/more-stores.d6aca3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vilocal/more-stores.png
// module id = d75J
// module chunks = 2